import SpecialParameter from '../config/special-parameter.config';

/* @ngInject */
export default function ParameterSupportService() {
    'use strict';

    function isSupported( uniquePart, parameterName ) {
        if (uniquePart != null && uniquePart.parameterValues != null && uniquePart.parameterValues.length > 0) {
            const parameterValues = uniquePart.parameterValues;
            for ( let i = 0; i < parameterValues.length; ++i ) {
                if (parameterValues[ i ].parameterName === parameterName) {
                    return parameterValues[ i ].value.toLowerCase() === 'true';
                }
            }
            return false;
        }
        return false;
    }

    return {
        /**
         * Determines whether a the name given matches a special Parameter.
         *
         * This method is case-sensitive!
         *
         * @param paramName - The Parameter name to check.
         * @return {boolean} - a {@link Boolean} which is `true` if the `paramName` is special, and `false` if it is not.
         */
        isSpecialParameter(paramName) {
            return Object.values(SpecialParameter).includes(paramName);
        },
        isKSIMSupported(uniquePart) {
            return isSupported(uniquePart, SpecialParameter.KSIM);
        },
        isLifeCalculatorSupported(uniquePart) {
            return isSupported(uniquePart, SpecialParameter.LIFE_CALCULATOR);
        }
    };
}
